window.addEventListener('DOMContentLoaded', (event) => {
	const speed = 0.75;
	const svgs = document.querySelectorAll('[data-draw]');
	// GSAP is not enqueued on relaunch pages (see inc/relaunch/performance.php).
	if (!svgs.length || typeof TweenMax === 'undefined') return;

	svgs.forEach(function (svg) {
		const path = svg.querySelector('path');
		const drawVals = { start: '0%', end: '0%' };

		TweenMax.set(path, {
			drawSVG: drawVals.start + ' ' + drawVals.end,
			transformOrigin: '50% 50%',
		});
		TweenMax.set(svg, { xPercent: -50, yPercent: -50 });

		svg.addEventListener(
			'mouseover',
			function () {
				TweenMax.killTweensOf(drawVals);

				drawVals.end =
					parseInt(drawVals.end) - parseInt(drawVals.start);
				drawVals.start = '0%';
				TweenMax.to(drawVals, speed, {
					start: '0%',
					end: '100%',
					onUpdate: function () {
						TweenMax.set(path, {
							drawSVG: drawVals.start + ' ' + drawVals.end,
						});
					},
				});
			},
			false
		);

		svg.addEventListener(
			'mouseleave',
			function () {
				TweenMax.to(drawVals, speed, {
					start: '100%',
					end: '100%',
					onUpdate: function () {
						TweenMax.set(path, {
							drawSVG: drawVals.start + ' ' + drawVals.end,
						});
					},
					onComplete: function () {
						drawVals.start = '0%';
						drawVals.end = '0%';
						TweenMax.set(path, {
							drawSVG: drawVals.start + ' ' + drawVals.end,
						});
					},
				});
			},
			false
		);
	});
});
